import { invitationKey, url, user_id, auth_key } from "../../constants";
import axios from "axios";

export const getResultsMap = async (key) => {
  try {
    const stoqqyLang = window.localStorage.getItem("stoqqyLang");
    const response = await axios.post(
      `${url}portfolio_map/${key}?Invitation=${invitationKey}&language=${stoqqyLang}`,
      {},
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return "error";
  }
};
